import React from "react";
import { Headers } from "../components/ui/heading";
import useAuthStore from "../stores/authStore";
import MerchantDashBoard from "../components/Dashboard/MerchantDashBoard";
import { Paper } from "@mantine/core";

function Dashboard() {
  const {
    computedUser: user,
    computedUserEmail: userEmail,
    computedUserName: userName,
  } = useAuthStore();

  const extractFirstName = (email) => {
    if (typeof email !== "string" || !email.trim()) return "Guest";

    const localPart = email.split("@")[0];
    const firstSegment = localPart.split(".")[0];

    if (!firstSegment || !firstSegment.trim()) return "Guest";

    const firstName =
      firstSegment.charAt(0).toUpperCase() +
      firstSegment.slice(1).toLowerCase();

    return firstName;
  };

  const displayName =
    userName || extractFirstName(userEmail || user?.sub || "");

  return (
    <div className="min-h-screen flex flex-col pb-16">
      <Paper shadow="xs" className="p-3 sm:p-6">
        <div className="mb-2 sm:mb-4 flex-shrink-0">
          <Headers name={`Welcome Back ${displayName}`} />
        </div>
        <div className="flex-1">
          <MerchantDashBoard />
        </div>
      </Paper>
    </div>
  );
}

export default Dashboard;
